import { useCallback, useEffect, useRef, useState } from "react";

export function useToast(duration = 2400) {
  const [message, setMessage] = useState("");
  const timerRef = useRef<number | undefined>(undefined);

  const showToast = useCallback(
    (nextMessage: string) => {
      setMessage(nextMessage);
      if (timerRef.current) window.clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(() => setMessage(""), duration);
    },
    [duration],
  );

  useEffect(() => {
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, []);

  return { message, showToast };
}